<template>
  <div class="w_100">
    <div class="ad1">
      <div class="between text_center">
        <lay-item-win
          style="width:222px;height:314px"
          v-for="(item, index) in list"
          :key="index"
		  :item='item'
          :consult-or-more="true"
        ></lay-item-win>
      </div>
    </div>
  </div>
</template>

<script>
import layItemWin from "views/home/components/layItemWin";
export default {
  components: {
    layItemWin,
  },
  data(){
	  return{
		  list:[]
	  }
  },
  created() {
  	this.$http.home.lawyerads({
		ad_id:7,
		limit:6
	}).then( res => {
		this.list = res.data.data
	})
  }
};
</script>

<style lang="scss" scope>
  .ad1 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
  }
</style>